export default __webpack_public_path__ + "assets/front/scss/classification-browsing.55dbf57ca378ff91cbcdee22b2440772.css";